import { useState } from "react";
import styles from "src/components/elements/ModalSheetListItem/modalSheetListItem.module.css";
import Dialog from "src/components/layout/Dialog/Dialog";

interface ModalSheetListItemWithDialogProps {
    text: string;
    onClick: () => void;
    icon?: React.ReactNode;
    divider?: boolean;
    warning?: boolean;
    dialog?: {
        title: string;
        content: React.ReactNode;
        onYes: {
            label: string;
        };
        onNo?: {
            onClick?: () => void;
            label: string;
        };
    };
}

const ModalSheetListItemWithDialog: React.FC<
    ModalSheetListItemWithDialogProps
> = (props) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handelDialogClose = () => {
        setIsDialogOpen(false);
    };

    return (
        <>
            <div
                className={styles.container}
                onClick={props.dialog ? () => setIsDialogOpen(true) : props.onClick}
                onKeyDown={props.dialog ? () => setIsDialogOpen(true) : props.onClick}
                role="button"
                tabIndex={0}
            >
                {props.icon && (
                    <div
                        className={`${styles.icon_container} ${
                            props.warning ? styles.warning : ""
                        }`}
                    >
                        {props.icon}
                    </div>
                )}
                <p className={props.warning ? styles.warning : ""}>
                    {props.text}
                </p>
            </div>
            {props.divider && <div className={styles.divider} />}
            {props.dialog && (
                <Dialog
                    isOpen={isDialogOpen}
                    handleClose={handelDialogClose}
                    title={props.dialog.title}
                    content={props.dialog.content}
                    onYes={{
                        onClick: props.onClick,
                        label: props.dialog.onYes.label,
                    }}
                    onNo={{
                        onClick:
                            props.dialog.onNo?.onClick || handelDialogClose,
                        label: props.dialog.onNo?.label || "キャンセル",
                    }}
                />
            )}
        </>
    );
};

export default ModalSheetListItemWithDialog;
